import { Reducer } from 'umi';

export const FILTER_EXTEND_NAMESPACE = 'intelligence_filter_extend';

interface TimeFilterType {
  type: string; // 'daily'|'weekly'|'monthly';
  filterType: string; // 'date'|'week'|'month';
  value: string[];
}
interface MarketFilterType {
  regions: string[];
  markets: string[];
  type: 'market' | 'region';
}
interface StateType {
  isOperate: boolean;
  isClickSensorTowTag: boolean;
  isClickSteamOrGameModeTag: boolean;
  topchartFilterExtendCommon: any;
  topchartFilterExtendByPage: Record<string, any>;
  timeFilterExtendCommon: TimeFilterType;
  timeFilterExtendOnlyDay: TimeFilterType;
  marketFilterExtendCommon: MarketFilterType;
  marketFilterExtendDropdown: MarketFilterType;
  isOperateByPage: Record<string, boolean>;
  isOperateDetail: boolean;
  isOperateRegion: boolean;
  detailFilterExtendCommon: any;
}
interface FilterExtendModelType {
  namespace: string;
  state: StateType;
  reducers: {
    saveAllSizerInitFunc: Reducer<StateType>;
    saveIsOperate: Reducer<StateType>;
    saveIsOperateByPage: Reducer<StateType>;
    saveTopchartFilterExtendCommon: Reducer<StateType>;
    saveTopchartFilterExtendByPage: Reducer<StateType>;
    saveTimeFilterExtendCommon: Reducer<StateType>;
    saveTimeFilterExtendOnlyDay: Reducer<StateType>;
    saveMarketFilterExtendCommon: Reducer<StateType>;
    saveMarketFilterExtendDropdown: Reducer<StateType>;
    saveDetailFilterExtendCommon?: Reducer<StateType>;
    saveIsOperateDetail?: Reducer<StateType>;
    saveIsOperateRegion?: Reducer<StateType>;
    setNormalTimeFilterExtend?: Reducer<StateType>;
    setReleaseTimeFilterExtend?: Reducer<StateType>;
    saveIsClickSensorTowTag?: Reducer<StateType>;
    saveIsClickSteamOrGameModeTag?: Reducer<StateType>;
  };
}
const sizerInit = {
  isOperate: false,
  topchartFilterExtendCommon: {},
  topchartFilterExtendByPage: {},
  isOperateDetail: false,
  isOperateRegion: false,
  isOperateByPage: {},
  isClickSensorTowTag: false,
  detailFilterExtendCommon: {},
  /** 公共时间筛选器继承 */
  timeFilterExtendCommon: {
    type: '', // daily, weekly, monthly
    filterType: '', // date, week,month
    value: ['', ''], // [string, string]
  },
  /** rangeReleaseTime之间normalTime时间筛选器继承 */
  normalTimeFilterExtend: {
    date: ['', ''],
    week: ['', ''],
    month: ['', ''],
  },
  /** rangeReleaseTime之间releaseTime时间筛选器继承 */
  releaseTimeFilterExtend: {
    date: ['', ''],
    week: ['', ''],
    month: ['', ''],
  },
  /** 单日粒度筛选器 */
  timeFilterExtendOnlyDay: {
    type: '',
    filterType: '',
    value: ['', ''],
  },
  /** 公共国家筛选器继承 */
  marketFilterExtendCommon: {
    regions: [],
    markets: ['global'],
    type: 'market',
  },
  /** 下拉国家筛选器 */
  marketFilterExtendDropdown: {
    regions: [],
    markets: ['global'],
    type: 'market',
  },
};
const FilterExtendModel: FilterExtendModelType = {
  namespace: FILTER_EXTEND_NAMESPACE,
  state: sizerInit,

  reducers: {
    saveAllSizerInitFunc(state: StateType, action: any) {
      return {
        ...sizerInit,
      };
    },
    saveIsOperate(state: StateType, action: any) {
      return {
        ...state,
        isOperate: action.payload,
      };
    },
    saveIsOperateByPage(state: StateType, action: any) {
      const { pageId, value } = action.payload || {};
      if (!pageId) {
        return state;
      }
      return {
        ...state,
        isOperateByPage: {
          ...(state.isOperateByPage || {}),
          [pageId]: value,
        },
      };
    },
    saveTopchartFilterExtendCommon(state: StateType, action: any) {
      return {
        ...state,
        topchartFilterExtendCommon: !action.payload ? {} : action.payload,
      };
    },
    saveTopchartFilterExtendByPage(state: StateType, action: any) {
      const { pageId, value, merge } = action.payload || {};
      if (!pageId) {
        return state;
      }
      const currentMap = state.topchartFilterExtendByPage || {};
      const prevValue = currentMap[pageId] || {};
      const shouldMerge = Boolean(merge);
      const nextValueRaw = value === null ? undefined : value || {};
      const nextValue =
        nextValueRaw === undefined
          ? undefined
          : shouldMerge
          ? { ...(prevValue || {}), ...nextValueRaw }
          : nextValueRaw;

      if (nextValue === undefined) {
        const { [pageId]: _, ...rest } = currentMap;
        return {
          ...state,
          topchartFilterExtendByPage: rest,
        };
      }

      return {
        ...state,
        topchartFilterExtendByPage: {
          ...currentMap,
          [pageId]: nextValue,
        },
      };
    },
    saveIsOperateDetail(state: StateType, action: any) {
      return {
        ...state,
        isOperateDetail: action.payload,
      };
    },
    saveIsOperateRegion(state: StateType, action: any) {
      return {
        ...state,
        isOperateRegion: action.payload,
      };
    },
    saveDetailFilterExtendCommon(state: StateType, action: any) {
      return {
        ...state,
        detailFilterExtendCommon: !action.payload ? {} : action.payload,
      };
    },
    saveTimeFilterExtendCommon(state: StateType, action: any) {
      return {
        ...state,
        timeFilterExtendCommon: action.payload,
      };
    },
    setNormalTimeFilterExtend(state: StateType, action: any) {
      return {
        ...state,
        normalTimeFilterExtend: action.payload,
      };
    },
    setReleaseTimeFilterExtend(state: StateType, action: any) {
      return {
        ...state,
        releaseTimeFilterExtend: action.payload,
      };
    },
    saveTimeFilterExtendOnlyDay(state: StateType, action: any) {
      return {
        ...state,
        timeFilterExtendOnlyDay: action.payload,
      };
    },
    saveMarketFilterExtendCommon(state: StateType, action: any) {
      return {
        ...state,
        marketFilterExtendCommon: action.payload,
      };
    },
    saveMarketFilterExtendDropdown(state: StateType, action: any) {
      return {
        ...state,
        marketFilterExtendDropdown: action.payload,
      };
    },
    saveIsClickSensorTowTag(state: StateType, action: any) {
      return {
        ...state,
        isClickSensorTowTag: action.payload,
      };
    },
    saveIsClickSteamOrGameModeTag(state: StateType, action: any) {
      return {
        ...state,
        isClickSteamOrGameModeTag: action.payload,
      };
    },
  },
};

export default FilterExtendModel;
